var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Chip } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { StatusEdicaoConfig, } from '../../enums/status-edicao.enum';
export var StatusEdicaoTag = function (_a) {
    var status = _a.status, _b = _a.size, size = _b === void 0 ? 'small' : _b, _c = _a.variant, variant = _c === void 0 ? 'filled' : _c, sx = _a.sx;
    var config = StatusEdicaoConfig[status];
    if (!config) {
        return null;
    }
    var getIcon = function () {
        var iconSize = size === 'small' ? '16px' : '20px';
        var iconStyle = { fontSize: iconSize, color: config.color };
        switch (config.icon) {
            case 'add_circle':
                return _jsx(AddCircleIcon, { sx: iconStyle });
            case 'check_circle':
                return _jsx(CheckCircleIcon, { sx: iconStyle });
            case 'edit':
                return _jsx(EditIcon, { sx: iconStyle });
            case 'delete':
                return _jsx(DeleteIcon, { sx: iconStyle });
            default:
                return _jsx(AddCircleIcon, { sx: iconStyle });
        }
    };
    return (_jsx(Chip, { label: config.label, size: size, variant: variant, icon: getIcon(), sx: __assign({ backgroundColor: config.bgColor, color: config.color, border: "1px solid ".concat(config.color, "20"), fontWeight: 500, '& .MuiChip-icon': {
                color: config.color,
            }, '& .MuiChip-label': {
                color: config.color,
                fontSize: size === 'small' ? '0.75rem' : '0.875rem',
            } }, sx) }));
};
